import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";
import { LessonPlanTemplateActionStatus } from "@/util/enum";

export const LessonPlanTemplateEditorResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	const actions: Promise<void>[] = [];
	const { templateId } = to.params;
	if (templateId) {
		lessonPlanTemplateModule.setLessonPlanTemplateAction(LessonPlanTemplateActionStatus.Edit);
		actions.push(lessonPlanTemplateModule.fetchLessonPlanTemplate({ templateId }));
		await Promise.all(actions);
	}
	else {
		lessonPlanTemplateModule.setLessonPlanTemplateAction(LessonPlanTemplateActionStatus.Add);
		lessonPlanTemplateModule.loadBuildinLessonPlanTemplate();
	}
	next();
};
